import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { Status, StatusTypeEnum } from './status-tag.model';
import { getIconByType, getLabelByType, mapStatusToColor } from './status-tag.utils';

const useStatusTag = (type?: StatusTypeEnum, status?: Status, tagValue?: ReactNode, positiveStatus?: boolean) => {
  const [t] = useTranslation();

  const colorStatus = mapStatusToColor(status, type, positiveStatus);
  const icon = getIconByType(type);
  const label = getLabelByType(t, type, status);
  const tagContent = tagValue ?? icon;

  return {
    colorStatus,
    label,
    tagContent
  };
};

export default useStatusTag;
